import { Link } from "react-router-dom";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Leaf, ShieldCheck, Info, MessageCircle } from "lucide-react";
import { Seo, absUrl, SITE_NAME, breadcrumb } from "../lib/seo";

export default function ChiSiamo() {
  const orgLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE_NAME,
    url: absUrl("/chi-siamo"),
    description: "Negozio online gestito da un distributore indipendente Herbalife che serve Rossano e Corigliano-Rossano.",
    areaServed: ["Rossano", "Corigliano-Rossano", "Calabria"],
  };
  const crumb = breadcrumb([{ name: "Home", path: "/" }, { name: "Chi siamo", path: "/chi-siamo" }]);

  return (
    <div className="mx-auto max-w-3xl px-6 py-14" data-testid="chi-siamo-page">
      <Seo
        title="Chi siamo | Herbalife Rossano"
        description="Il negozio è gestito da un distributore indipendente Herbalife. Scopri come funziona l'acquisto online dei prodotti Herbalife e come contattare il distributore."
        canonical="/chi-siamo"
        jsonLd={[orgLd, crumb]}
      />
      <h1 className="text-3xl sm:text-4xl font-extrabold font-display text-slate-900 flex items-center gap-3"><Leaf className="w-8 h-8 text-emerald-600" /> Chi siamo</h1>

      <div className="mt-6 space-y-5 text-slate-600 leading-relaxed">
        <p>Questo sito è il <strong>negozio online di un distributore indipendente Herbalife</strong> attivo nella zona di Rossano e Corigliano-Rossano. Offriamo la possibilità di consultare il catalogo e acquistare comodamente online i prodotti Herbalife.</p>
        <p>Il nostro obiettivo è rendere semplice la consultazione delle schede prodotto e l'acquisto online, seguendo il cliente durante l'ordine.</p>
      </div>

      <Card className="mt-8 p-5 rounded-2xl border-amber-200 bg-amber-50/60" data-testid="chi-siamo-disclaimer">
        <h2 className="font-semibold text-slate-900 flex items-center gap-2"><Info className="w-5 h-5 text-amber-600" /> Distributore indipendente</h2>
        <p className="mt-2 text-sm text-slate-600 leading-relaxed">Herbalife è un marchio di Herbalife Ltd. Questo sito è gestito da un distributore indipendente e <strong>non è un sito ufficiale Herbalife</strong>. Le informazioni e i prezzi si riferiscono esclusivamente al negozio online del distributore indipendente.</p>
      </Card>

      <Card className="mt-6 p-5 rounded-2xl border-slate-200" data-testid="chi-siamo-trust">
        <h2 className="font-semibold text-slate-900 flex items-center gap-2"><ShieldCheck className="w-5 h-5 text-emerald-600" /> Acquisto online sicuro</h2>
        <p className="mt-2 text-sm text-slate-600 leading-relaxed">Gli ordini si completano online e il pagamento avviene tramite checkout protetto Stripe: i dati della carta non vengono memorizzati sul nostro sito.</p>
      </Card>

      <div className="mt-8">
        <Link to="/contatta-il-distributore"><Button className="rounded-full" data-testid="chi-siamo-contact-btn"><MessageCircle className="w-4 h-4 mr-2" /> Contatta il distributore</Button></Link>
      </div>
    </div>
  );
}
